import OutputNodePane from './OutputNodePane'

export default OutputNodePane
